define('views/components/purchase_information/purchase_information',['require','backbone','marionette','text!templates/components/purchase_information/purchase_information.html'],function(require){

    var Backbone = require('backbone');
    require('marionette');

    var temp = require("text!templates/components/purchase_information/purchase_information.html");
    return Backbone.Marionette.ItemView.extend({
        tagName: 'div',
        template: _.template(temp),

        initialize: function(){
            this.listenTo(
                App.vent,
                "transaction-successful",
                this._onSuccessfulTransaction
              );
        },

        ui: function(){
            return {
                container : '#purchase-information',
                closeButton : '#close-purchase-information'
            };
        },

        events: {
            'click @ui.closeButton': 'closeButtonClicked'
        },

        closeButtonClicked: function(){
            this.ui.container.addClass('d-none');
        },

        _onSuccessfulTransaction: function(){
            this.ui.container.removeClass('d-none');
            window.setTimeout(function () {
                App.vent.trigger('transaction-successful-clear-basket');

            }, 2 * 1000);
        },

        templateHelpers: function(){
            return {
                totalPrice: App.context.basket.get('products').reduce( function(total, currentProduct){
                    var dollar_try = parseFloat(App.context.constants.dollar_try);

                    if (App.utils.getPricingMode() == 'TRY' || App.utils.getPricingMode() == 'TRY_VAT') {
                        // Show TRY price
                        if (currentProduct.product.exchange_currency === 3) {
                            // Price set in TRY, add directly
                            return total + currentProduct.product.effective_price * currentProduct.count;
                        } else {
                            // Price set in USD, convert
                            return total + (currentProduct.product.effective_price * dollar_try * currentProduct.count);
                        }
                    } else {
                        // Show USD price
                        if (currentProduct.product.exchange_currency === 3) {
                            // Price set in TRY, convert
                            return total + ((currentProduct.product.effective_price / dollar_try) * currentProduct.count);
                        } else {
                            // Price set in USD, add directly
                            return total + currentProduct.product.effective_price * currentProduct.count;
                        }
                    }
                }, 0)
            };
        },
    });
});
